import hapticsOnPress from './hapticsOnPress';
import isDesktopUserAgent from './isDesktopUserAgent';

export default function handleLongPress<T extends (...args: any[]) => any>(
  fn: T,
): T {
  if (isDesktopUserAgent) {
    return (() => {}) as T;
  }
  return hapticsOnPress(fn) as T;
}
